:host {
  display: block;
}

lilu-language-selector {
  position: relative;
  font-family: var(--primary-font);
  font-size: 14px;

  &.hide-mobile {
    @include breakpointMax('lg') {
      display: none;
    }
  }

  &.hide-desktop {
    @include breakpointMin('lg') {
      display: none;
    }
  }
}

.language-selector {
  // styling for header mode
  display: flex;
  align-items: center;
  pointer-events: none;

  &-label {
    font-weight: var(--font-weight-semibold);
    margin-left: 5px;
  }

  lilu-icon {
    font-size: 18px;
  }

  &-label,
  lilu-icon {
    color: var(--color-nero);
  }

  &-select {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    &:hover {
      cursor: pointer;
    }
  }

  // styling for mobile + tablet mode
  &-list {
    margin: 20px 0;
    padding: 0 0 0 15px;
    list-style: none;

    li {
      width: 33.33333%;
      float: left;
      padding-right: 15px;
      text-align: center;

      .language-selector-item {
        display: block;
        color: var(--color-white);
        font-size: 16px;
        text-align: center;
        text-decoration: none;
        background: var(--color-nero);
        border-radius: 3px;
        padding: 8px;

        &-active {
          color: var(--color-white);
          background: var(--color-nero-hover);
        }

        &-title {
          display: inline-block;
          @include breakpointMax('sm') {
            display: none;
          }
        }

        &-label {
          text-transform: uppercase;
          @include breakpointMin('md') {
            display: none;
          }
        }
      }
    }
  }
}
